module.exports = __webpack_public_path__ + "589743af5bad3d1de51a4d7293e87bba.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/tiers/trophy-shelf-0.png
// module id = 3004
// module chunks = 0